import { Button, Form } from 'antd'
import React from 'react'
import styles from'./antdSubmit.module.css'

function AntdSubmit({text,buttonStyle,onClick, className}) {
  return (
    <Form.Item className={className} >
      <Button  onClick={onClick} type="primary" htmlType="submit" className={styles.antdButton} style={buttonStyle}>
        {text}
      </Button>
    </Form.Item>
  )
}

export default AntdSubmit